import tw from 'twin.macro';
import styled from 'styled-components';

const Heading5 = styled.h5(() => [tw`text-xl md:text-2xl mt-6 mb-4 font-medium`]);

export default Heading5;
